import { FormField } from '@nimbus-ds/patterns';
import type { MaxDiscountAmountType } from '@tiendanube/common/src/domains/marketing/coupons/types';
import { InputNumberNimbus, Stack, RadioButtonGroup } from 'commons/components';
import type { InterfaceNameValue } from 'commons/types';
import { useGetCurrency } from 'domains/Auth/hooks';
import { useTranslationMarketing } from 'domains/Marketing/hook';

interface MaxDiscountAmountProps {
  onChange: ({ name, value }: InterfaceNameValue) => void;
  value: string;
  type: MaxDiscountAmountType;
  error?: string;
}

export function MaxDiscountAmount({
  onChange,
  value,
  type,
  error,
}: Readonly<MaxDiscountAmountProps>) {
  const t = useTranslationMarketing(
    'coupons.couponForm.limits.maxDiscountAmount',
  );
  const tErrors = useTranslationMarketing();
  const { symbol } = useGetCurrency();

  const inputAppearance = error ? 'danger' : undefined;

  const handleTypeChange = ({ value: newType }: InterfaceNameValue) => {
    onChange({ name: 'maxDiscountAmountType', value: newType });
  };

  return (
    <Stack column align="stretch" spacing="tight">
      <Stack.Item>
        <RadioButtonGroup
          label={t('title')}
          boldLabel
          name="maxDiscountAmountType"
          data-testid="maxDiscountAmountTypeGroup"
          options={[
            {
              label: t('type.unlimited'),
              value: 'unlimited',
            },
            {
              label: t('type.limited'),
              value: 'limited',
            },
          ]}
          onChange={handleTypeChange}
          value={type}
        />
      </Stack.Item>
      {type === 'limited' && (
        <Stack.Item>
          <FormField
            helpText={error ? tErrors(error) : undefined}
            showHelpText={!!error}
            appearance={inputAppearance}
            id="maxDiscountAmount"
          >
            <InputNumberNimbus
              name="maxDiscountAmount"
              type="float"
              id="maxDiscountAmount"
              data-testid="maxDiscountAmountInput"
              append={symbol}
              appendPosition="start"
              value={value}
              onChange={({ target: { name, value } }) =>
                onChange({ name, value })
              }
              appearance={inputAppearance}
            />
          </FormField>
        </Stack.Item>
      )}
    </Stack>
  );
}
